// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__1vQvT","icon":"SearchBar_icon__1hH7D","input":"SearchBar_input__1hrKm"};